export const QUESTION_TYPE = {
    singleCorrect: "Single Correct",
    multipleCorrect: "Multiple Correct",
    fillTheBlanks: "Fill in the Blanks",
    numerical: "Numerical",
};